import mixpanel from 'mixpanel-browser';

class Analytics {
  init(token: string) {
    mixpanel.init(token, {
      record_collect_fonts: true,
    });
  }
  //  ex anaylytics.track('song_played', {songID:'...', songTitle:'...'})
  track(eventName: string, properties?: object) {
    if (process.env.NODE_ENV === 'production') mixpanel.track(eventName, properties);
  }

  //  ex anaylytics.identify("userID")
  identify(userId: string): void {
    mixpanel.identify(userId);
  }

  //  ex anaylytics.register({client:'123456', roomID:'...', userType:''})
  register(properties: object): void {
    mixpanel.register(properties);
  }

  //  ex anaylytics.clientData({client:'123456', roomID:'...', userType:''})
  clientData(properties: object): void {
    mixpanel.people.set(properties);
  }

  // ex anaylytics.people.increment({"query result": 17})
  clientDataIncrement(properties: object): void {
    mixpanel.people.increment(properties);
  }

  //  ex anaylytics.increment('song_played', {songID:'...', songTitle:'...'})
  increment(property: string, value: number): void {
    mixpanel.people.increment(property, value);
  }

  startRecording(): void {
    mixpanel.start_session_recording();
  }

  stopRecording(): void {
    mixpanel.stop_session_recording();
  }
}

const analytics = new Analytics();

export default analytics;
